const Domain = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Domain')
const PushNotifications = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/PushNotifications/Index.vue')
const Emails = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Emails/Index')
const EmailsConfiguration = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Emails/tabs/Configuration')
const EmailsTemplates = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Emails/tabs/Templates')
const Privacy = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Privacy')
const SEO = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/SEO')
const Tracking = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Tracking')
const Achievements = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Achievements')
const Notifications = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Notifications')
const Comments = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Comments')
const Community = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Community')
const Activity = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Settings/Pages/Routes/Activity')
const Attributes = () => import(/* webpackChunkName: "v2-hub-settings" */ '@app2/modules/Hubs/Editor/Pages/Sidebar/Attributes')

export const beforeEditorLeave = (to, from, next, root) => {
  if ( root.hub.hasChanged ) {
    root.$store.commit('v2/hubs/settings/SET_EXIT_ROUTE', to)
    root.$bvModal.show('exit-settings-dialog');
    next(false);
    return;
  }
  next();
}

export default [
  {
    path: 'domain',
    name: 'hubSettingsDomain',
    component: Domain,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'emails',
    name: 'hubSettingsEmails',
    component: Emails,
    redirect: {
      name: 'hubSettingsEmailsConfiguration',
    },
    children: [
      {
        path: 'configuration',
        name: 'hubSettingsEmailsConfiguration',
        component: EmailsConfiguration,
        props: true,
        meta: { hideSidenavBackButton: true, showSubnav: true },
      },
      {
        path: 'templates',
        name: 'hubSettingsEmailsTemplates',
        component: EmailsTemplates,
        props: true,
        meta: { hideSidenavBackButton: true, showSubnav: true },
      },
    ]
  },
  {
    path: 'community',
    name: 'hubSettingsCommunity',
    component: Community,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'push-notifications',
    name: 'hubSettingsPushNotifications',
    component: PushNotifications,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: '',
    name: 'hubSettingsPrivacy',
    component: Privacy,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'seo',
    name: 'hubSettingsSEO',
    component: SEO,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'tracking',
    name: 'hubSettingsTracking',
    component: Tracking,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'pages',
    redirect: {
      name: 'hubSettingsPrivacy',
    }
  },
  {
    path: 'achievements',
    name: 'hubSettingsAchievements',
    component: Achievements,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'notifications',
    name: 'hubSettingsNotifications',
    component: Notifications,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'comments',
    name: 'hubSettingsComments',
    component: Comments,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'activity',
    name: 'hubSettingsActivity',
    component: Activity,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
  {
    path: 'attributes',
    name: 'hubSettingsAttributes',
    component: Attributes,
    meta: { hideSidenavBackButton: true, showSubnav: true },
  },
];
